import { catchError, of, OperatorFunction, throwError } from 'rxjs';

export function recoverUnlessStrict<T, F>(
	strict: boolean,
	fallback: () => F
): OperatorFunction<T, T | F> {
	return catchError((error: unknown) =>
		strict ? throwError(() => error) : of(fallback())
	);
}
